// ExcelPack homepage interactivity: scroll progress + sticky header + scroll animations

document.addEventListener('DOMContentLoaded', () => {
  const progressBar = document.querySelector('.ep-scroll-progress__bar');
  const header = document.querySelector('header');
  const stickyHeader = document.querySelector('sticky-header');

  const initHeroVideo = () => {
    const video = document.querySelector('[data-ep-hero-video]');
    if (!video) return;
    const source = video.querySelector('source[data-src]');
    if (!source) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let loaded = false;

    const loadVideo = () => {
      if (loaded) return;
      loaded = true;
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      video.load();
    };

    // Hero is above-the-fold: load after DOM is ready (doesn't block initial paint).
    loadVideo();

    if (!prefersReducedMotion) {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }
  };

  const updateProgress = () => {
    if (!progressBar) {
      return;
    }

    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    const progress = maxScroll > 0 ? (window.scrollY / maxScroll) * 100 : 0;
    progressBar.style.width = `${progress}%`;
  };

  const handleScroll = () => {
    if (header) {
      header.classList.toggle('ep-header--scrolled', window.scrollY > 12);
    }
    // Add scrolled class to sticky-header for shadow effect
    if (stickyHeader) {
      stickyHeader.classList.toggle('scrolled', window.scrollY > 20);
    }
    updateProgress();
  };

  handleScroll();
  initHeroVideo();

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', updateProgress);

  const initAnchorScroll = () => {
    const anchorLinks = document.querySelectorAll(
      'a[href*="#coup-de-coeur"], a[href*="#faq"]'
    );

    if (!anchorLinks.length) return;

    anchorLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const url = new URL(link.href, window.location.origin);
        const onHome = window.location.pathname === '/' || window.location.pathname === '';

        if (!onHome || !url.hash) {
          return;
        }

        const targetId = url.hash.replace('#', '');
        const target = document.getElementById(targetId);

        if (!target) {
          return;
        }

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', url.hash);
      });
    });
  };

  // ============================================
  // Scroll Animations with IntersectionObserver
  // ============================================

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReducedMotion) {
    // Select all animated elements
    const animatedElements = document.querySelectorAll(
      '.ep-animate, .ep-animate-stagger, .ep-animate-left, .ep-animate-right, .ep-animate-scale'
    );

    // Auto-detect sections to animate (sections that benefit from reveal)
    const sectionsToAnimate = document.querySelectorAll(
      '.collections-grid, .sellers-grid, .process-container, .faq-container, .testimonials-container, .section-header'
    );

    // Add animation classes to detected sections
    sectionsToAnimate.forEach((section) => {
      if (!section.classList.contains('ep-animate') &&
          !section.classList.contains('ep-animate-stagger')) {
        // Grid sections get stagger animation
        if (section.classList.contains('collections-grid') ||
            section.classList.contains('sellers-grid')) {
          section.classList.add('ep-animate-stagger');
        } else {
          section.classList.add('ep-animate');
        }
      }
    });

    // Collect all elements to observe
    const allAnimated = document.querySelectorAll(
      '.ep-animate, .ep-animate-stagger, .ep-animate-left, .ep-animate-right, .ep-animate-scale'
    );

    // IntersectionObserver callback
    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ep-visible');
          observer.unobserve(entry.target); // Stop observing once visible
        }
      });
    };

    // Create observer with options
    const observerOptions = {
      root: null, // viewport
      rootMargin: '0px 0px -50px 0px', // trigger slightly before element enters
      threshold: 0.1 // 10% visible
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe all animated elements
    allAnimated.forEach((element) => {
      observer.observe(element);
    });
    initAnchorScroll();
  } else {
    // If reduced motion is preferred, show all elements immediately
    document.querySelectorAll(
      '.ep-animate, .ep-animate-stagger, .ep-animate-left, .ep-animate-right, .ep-animate-scale'
    ).forEach((el) => el.classList.add('ep-visible'));
    initAnchorScroll();
  }
});
